import { css, useTheme } from "@emotion/react";
import omit from "lodash/fp/omit";
import { useState } from "react";

import {
  Icon,
  Button,
  DetailsBox,
  Heading,
  InlineList,
  Section,
  TypographyBlock,
  useThemeProps,
  generateUniqueId,
  withDefaultProps,
} from "../../wsui/base";

// Item: {
//   as: Box,
//   borderRadius: 2,
//   color: itemColor,
//   style: {
//     [[
//       "&.wsui-is-expanded",
//       "&:has(.wsui-details-summary-toggle.wsui-is-interactive:hover)",
//       "&:has(.wsui-details-summary-toggle.wsui-is-interactive:focus-visible)",
//     ]]: {
//       backgroundColor: itemColor ? [itemColor, "+50"] : undefined,
//     },
//   },
//   components: {
//     Summary: withDefaultProps(Heading, {
//       style: { maxWidth: "none" },
//     }),
//     SummaryToggleIcon: {
//       color: itemColor ? [itemColor, 600] : "primary",
//       size: "1.25em",
//     },
//   },
// },

const HeadingComponent = ({
  expandableTextModuleOwnerState,
  children,
  ...restProps
}) => {
  const { titleIcon, titleIconProps, contentJustify } =
    expandableTextModuleOwnerState;
  return (
    <span
      css={css`
        display: flex;
        gap: 0.5em;
        align-items: start;
        justify-content: ${contentJustify};
      `}
      {...restProps}
    >
      {titleIcon && (
        <Icon
          name={titleIcon}
          css={css`
            align-self: center;
            flex: none;
          `}
          {...titleIconProps}
        />
      )}
      {children}
    </span>
  );
};

export default function ExpandableTextModule(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();

  props = useThemeProps({
    props,
    name: "MunicipioExpandableTextModule",
  });
  props = useThemeProps({
    props,
    name: "MunicipioTextModule",
  });

  let {
    title,
    titleIcon,
    titleIconProps,
    buttonProps = {},
    color,
    align,
    description,
    links,
    headingVariant,
    borderRadius = 2,
    headingId,
    ...restProps
  } = omit(["expandble"], props);
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const inlineListAlign =
    contentAlign === "left"
      ? "start"
      : contentAlign === "right"
        ? "end"
        : contentAlign === "center"
          ? "center"
          : undefined;
  const contentJustify =
    contentAlign === "right"
      ? "flex-end"
      : contentAlign === "center"
        ? "center"
        : "flex-start";

  const [defaltHeadingId] = useState(
    () => `module-heading-${generateUniqueId()}`,
  );
  headingId = headingId || defaltHeadingId;

  const ownerState = {
    title,
    titleIcon,
    titleIconProps,
    buttonProps,
    color,
    contentAlign,
    contentJustify,
    description,
    links,
    headingVariant,
    borderRadius,
    headingId,
    ...restProps,
  };

  return (
    <DetailsBox
      color={color || "transparent"}
      borderRadius={borderRadius}
      summary={title}
      components={{
        Summary: withDefaultProps(Heading, {
          style: { maxWidth: "none" },
          variant: headingVariant,
          id: headingId,
          align: contentAlign,
        }),
        SummaryContent: withDefaultProps(HeadingComponent, {
          expandableTextModuleOwnerState: ownerState,
        }),
      }}
      {...restProps}
    >
      <Section>
        <TypographyBlock align={contentAlign}>{description}</TypographyBlock>
        {!!links?.length && (
          <InlineList
            align={inlineListAlign}
            css={css`
              margin-top: ${theme.getLength(5)};
            `}
          >
            {links.map(({ link, variant }, index) => (
              <Button
                key={index}
                {...link}
                variant={variant ?? "primary"}
                {...buttonProps}
              />
            ))}
          </InlineList>
        )}
      </Section>
    </DetailsBox>
  );
}
